import {
    useAppSelector, useAppSelectorWithShallowEquality,
} from 'hooks'
import ChannelSidebarView from './ChannelSidebarView'
import {NinchatCannedMessage} from 'api/types/properties'
import {NinchatState} from 'api/types'
import React from 'react'
import {useTranslation} from 'react-i18next'

type ChannelSidebarProps = {
    chat?: {
        channel_id?: string
        user_id?: string
    }
    isAudienceChannel: boolean
    hasCannedMessages: boolean
    channelTopic: string | null
    onSelectCannedMessage: (message: NinchatCannedMessage) => void
    onToggleChannelSidebar: (event?: React.MouseEvent<HTMLButtonElement>) => void
}

const ChannelSidebar: React.FC<ChannelSidebarProps> = ({
    chat,
    channelTopic,
    isAudienceChannel,
    hasCannedMessages,
    onSelectCannedMessage,
    onToggleChannelSidebar,
}) => {
    const {t} = useTranslation()
    const showChannelSidebar = useAppSelector(({ui}) => ui.show_channel_sidebar || false)

    const cannedMessagesClassicView = useAppSelectorWithShallowEquality(
        ({ninchat}: {ninchat: NinchatState}) => ninchat?.user_settings?.canned_messages_classic_view ?? false,
    )

    const audienceInfoText = t('Audience info')
    const cannedMessagesText = t('Canned messages')
    const channelInfoText = t('Channel info')
    const channelMembersText = t('Channel members')
    const channelTopicText = t('Channel topic')
    const hideAudienceInfoText = t('Hide audience info')
    const hideChannelInfoText = t('Hide channel info')


    return (
        <ChannelSidebarView
            audienceInfoText={audienceInfoText}
            cannedMessagesText={cannedMessagesText}
            channelId={chat?.channel_id}
            channelInfoText={channelInfoText}
            channelMembersText={channelMembersText}
            channelTopic={channelTopic}
            channelTopicText={channelTopicText}
            hasCannedMessages={hasCannedMessages}
            hideAudienceInfoText={hideAudienceInfoText}
            hideChannelInfoText={hideChannelInfoText}
            isAudienceChannel={isAudienceChannel}
            onSelectCannedMessage={onSelectCannedMessage}
            onToggleChannelSidebar={onToggleChannelSidebar}
            showCannedMessagesClassicView={cannedMessagesClassicView}
            showChannelSidebar={showChannelSidebar}
            userId={chat?.user_id}
        />
    )
}

ChannelSidebar.defaultProps = {chat: {}}

export default ChannelSidebar
